import Category from "../../../components/category/category";

import { habitat } from "../../../constants/habitat";

export default function Habitat() {
    return (
        <section id="Habitat">
            <Category>Habitat</Category>
            {habitat.map((val, i) => (
                <p key={ i } className="article-information">{val}</p>
            ))}
        </section>
    );
};